var _style, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.3999,
    y1: 256,
    x2: 349.5996,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7750F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A95DC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333,273.1c0-2.1-0.9-4-2.4-5.4l-24.4-22.4v-61c26.9-17.1,43.4-47,43.4-79c0-51.6-42-93.6-93.6-93.6 s-93.6,42-93.6,93.6c0,32.1,16.5,62,43.4,79v267.2c0,2,0.8,3.8,2.1,5.2l40.3,41.3c1.5,1.5,3.4,2.3,5.4,2.3c1.8,0,3.6-0.7,5.1-2 l45.3-41.4c1.6-1.4,2.4-3.4,2.4-5.5V402l24.3-23.4c1.5-1.4,2.3-3.4,2.3-5.5c0-2.1-0.9-4-2.4-5.4l-20.7-19l20.8-20.1 c1.5-1.4,2.3-3.4,2.3-5.5c0-2.1-0.9-4-2.4-5.4l-20.7-19l20.8-20.1C332.2,277.2,333,275.2,333,273.1z M293.7,293.4 c-1.5,1.4-2.3,3.4-2.3,5.5c0,2.1,0.9,4,2.4,5.4l20.7,19l-20.8,20.1c-1.5,1.4-2.3,3.4-2.3,5.5c0,2.1,0.9,4,2.4,5.4l20.7,19 l-20.8,20.1c-1.5,1.4-2.3,3.4-2.3,5.4v49.3l-30.3,27.7v-105h-15v103.6l-25.3-25.9V180.1c0-2.7-1.4-5.2-3.8-6.5 c-24.4-13.9-39.6-40.1-39.6-68.3c0-43.3,35.3-78.6,78.6-78.6c43.3,0,78.6,35.3,78.6,78.6c0,28.2-15.2,54.3-39.6,68.3 c-2.3,1.3-3.8,3.8-3.8,6.5V248c0,0.6,0.1,1.2,0.2,1.8l0.2,0.8c0.4,1.4,1.1,2.7,2.2,3.7l20.7,19L293.7,293.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.5,
    y1: 105.1001,
    x2: 304.5,
    y2: 105.1001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7750F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A95DC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,56.6c-26.7,0-48.5,21.8-48.5,48.5s21.8,48.5,48.5,48.5s48.5-21.8,48.5-48.5S282.7,56.6,256,56.6z  M256,138.6c-18.5,0-33.5-15-33.5-33.5s15-33.5,33.5-33.5c18.5,0,33.5,15,33.5,33.5S274.5,138.6,256,138.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.1001,
    y1: 352.1499,
    x2: 261.0996,
    y2: 352.1499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7750F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A95DC"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 246.1,
    y: 344.8,
    className: "st2",
    width: 15,
    height: 14.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateKey);
export default __webpack_public_path__ + "static/media/private_key.58e008b86695d146f8105c260a171bdf.svg";
export { ForwardRef as ReactComponent };